var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyUrl = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Copy-URL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-calendar/Outlined",
    transform: "translate(1.875, 1.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_edit",
    transform: "translate(9, 9) rotate(-45) translate(-9, -9)translate(1, 5)",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52000008,4 C1.52000008,2.63199997 2.63199997,1.51999969 4,1.51999969 L7.2,1.51999969 L7.2,3.34882454e-14 L4,3.34882454e-14 C1.79200001,3.34882454e-14 2.8443151e-14,1.79200001 2.8443151e-14,4 C2.8443151e-14,6.20799999 1.79200001,8 4,8 L7.2,8 L7.2,6.48000031 L4,6.48000031 C2.63199997,6.48000031 1.52000008,5.36800003 1.52000008,4 Z M4.8,4.8 L11.2,4.8 L11.2,3.2 L4.8,3.2 L4.8,4.8 Z M12,3.34882454e-14 L8.8,3.34882454e-14 L8.8,1.51999969 L12,1.51999969 C13.368,1.51999969 14.4800003,2.63199997 14.4800003,4 C14.4800003,5.36800003 13.368,6.48000031 12,6.48000031 L8.8,6.48000031 L8.8,8 L12,8 C14.208,8 16,6.20799999 16,4 C16,1.79200001 14.208,3.34882454e-14 12,3.34882454e-14 Z",
    id: "Vector"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyUrl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Copy-URL.2f99d2a98a5af8b5c07a53d74f80186a.svg";